import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { isNull } from 'lodash/fp';
import PropTypes from 'prop-types';
import ItemSelectorDetails from './ItemSelectorDetails';
import ItemSelectorValidationErrors from './ItemSelectorValidationErrors';
import { CopyStylesEmpty, CopyStylesProduct, CopyStylesProductInfo } from '../../../themes/svg/copyStylesIcons';

import { ItemSelectorCheckbox, StyledItemSelector, ItemSelectorIcon } from './styles';

const ItemSelector = ({
  itemId,
  addItemToSelection,
  removeItemFromSelection,
  isSelected,
  itemName,
  details,
  validation,
  newWindowLabel,
  validateItems,
  sourceItem,
}) => {
  const onChange = useCallback(() => {
    isSelected
      ? removeItemFromSelection(itemId)
      : addItemToSelection(itemId);
  }, [isSelected, removeItemFromSelection, itemId, addItemToSelection]);

  useEffect(() => {
    validateItems(sourceItem, itemId);
  }, [sourceItem, itemId, validateItems]);

  const disabled = !validation.isValid;

  const hasProduct = useMemo(() => !isNull(details));

  const [isIconHovering, setIconHovering] = useState(false);

  return (
    <StyledItemSelector
      tabIndex="-1"
      key={`selector-${itemId}`}
      isSelected={isSelected}
      disabled={disabled}
    >
      <ItemSelectorCheckbox
        name={`checkbox-${itemId}`}
        checked={isSelected}
        label={itemName}
        disabled={disabled}
        onChange={onChange}
        itemId={itemId}
        newWindowLabel={newWindowLabel}
      />
      <ItemSelectorIcon
        onMouseEnter={() => setIconHovering(true)}
        onMouseLeave={() => setIconHovering(false)}
      >
        { hasProduct && validation.isValid && <CopyStylesProduct /> }
        { hasProduct && !validation.isValid && <CopyStylesProductInfo /> }
        { !hasProduct && <CopyStylesEmpty /> }
      </ItemSelectorIcon>
      {(validation.isValid
        || (!validation.isValid && isIconHovering))
        && details && <ItemSelectorDetails {...details} />}
      {!validation.isValid
        && !isIconHovering
        && <ItemSelectorValidationErrors errors={validation.errors} />}
    </StyledItemSelector>
  );
};

ItemSelector.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  addItemToSelection: PropTypes.func.isRequired,
  removeItemFromSelection: PropTypes.func.isRequired,
  newWindowLabel: PropTypes.shape({}).isRequired,
  validateItems: PropTypes.func.isRequired,
  details: PropTypes.shape({
    brand: PropTypes.string,
    productName: PropTypes.string,
    color: PropTypes.string,
  }),
  validation: PropTypes.shape({
    isValid: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
  }),
  sourceItem: PropTypes.string.isRequired,
};
ItemSelector.defaultProps = {
  details: undefined,
  validation: {
    isValid: true,
  },
};

export default ItemSelector;
